import React, { useEffect, useState } from "react";
import PonudeLeasingAdmin from "./PonudeLeasingAdmin";
import PonudeRestRoles from "./PonudeRestRoles";

const Ponude = ({ loggedUser }) => {
  const [role, setRole] = useState(null);

  useEffect(() => {
    setRole(loggedUser?.role);
  }, [loggedUser]);

  return role === "Leasing admin" ? (
    <PonudeLeasingAdmin />
  ) : (
    <PonudeRestRoles />
  );
};

export default Ponude;
